import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TypeCard from '~/components/TypeCard'

const CollectionTypes: React.FC = () => {
  const { t } = useTranslation()
  const {
    isLoading: isBusyData,
    data: collectionMethods,
    refetch: fetchData
  } = DairyQuery.getCollectionMethodsList()

  useEffect(() => {
    fetchData()
  }, [t])

  const { rows } = collectionMethods ? collectionMethods : { rows: [] }

  return (
    <Layout
      title={t('Collection types')}
      isBusy={isBusyData}
      childContainerSize={'auto'}
      fontSizeHeader={'18px'}
      useSpinner
    >
      <TypeCard rows={rows} />
    </Layout>
  )
}
export default CollectionTypes
